import { BaseCameraStream } from './BaseCameraStream';

export class CameraStreamPlayer extends BaseCameraStream {
    maskedUrl;
    playerEndpointId;
    #playerEndpoint;

    //promise (controlled outside)
    activationPromise;

    //state
    live;
    #activating;

    constructor(kurentoId, camConfig) {
        super();
        const {
            camId,
            videoData: { playerEndpointId, streamType, url },
        } = camConfig;

        this.cameraId = camId;
        this.kurentoId = kurentoId;
        this.streamType = streamType;
        this.playerEndpointId = playerEndpointId;
        this.#setVideoUrl(url);
        this.updateLogHeader();
    }

    async activate() {
        try {
            if (!this.playerEndpointId || this.#activating) return;
            this.#activating = true;
            this.#playerEndpoint = await this.getMediaObjectById(this.playerEndpointId);
            this.log('activate(): activated PlayerEndpoint');
            this.#activating = false;
            this.live = true;
        } catch (err) {
            this.#activating = false;
            this.activationPromise = null;
            this.handle(err, 'activate()');
        }
    }
    async connect(webRTCEndpoint, action = 'connect') {
        try {
            await this.connectMediaElements(this.#playerEndpoint, webRTCEndpoint, action);
            this.log(`${action}(): ${action}ed WebRTCEndpoint id=${webRTCEndpoint.id}`);
        } catch (err) {
            this.handle(err, `${action}()`);
        }
    }
    async disconnect(webRTCEndpoint) {
        try {
            await this.connect(webRTCEndpoint, 'disconnect');
        } catch (err) {
            this.handle(err, 'disconnect()');
        }
    }
    async update(playerEndpointId, kurentoId) {
        try {
            this.updateKurentoId(kurentoId);
            this.playerEndpointId = playerEndpointId;
            this.live = false;
            await (this.activationPromise = this.activate());
            this.log(`update(): updated CameraStreamPlayer to new config. New PlayerEndpointId=${playerEndpointId}`);
        } catch (err) {
            this.handle(err, 'update()');
        }
    }

    updateLogHeader() {
        this.fullHeader = `[CameraStreamPlayer kurentoId=${this.kurentoId}, cameraId=${this.cameraId}, streamType=${this.streamType}]`;
    }

    #setVideoUrl(videoUrl) {
        this.videoUrl = videoUrl;
        this.maskedUrl = videoUrl?.replaceAll(/(\w+):\/\/(\w+):(\S+)@(\S+)/gi, '$1://$2:xxx@$4') || 'NoURL';
    }
}
